"use client";

import * as React from "react";
import type { PageHeaderV2Config } from "components/ui/v2/page-header-v2";
import { ListPageShell } from "components/ui/v2/layout/page-shell";

export interface MaintainerPageV2Props {
  /** Props del header */
  header: PageHeaderV2Config;
  /** Barra de búsqueda */
  searchValue?: string;
  onSearchChange?: (value: string) => void;
  searchPlaceholder?: string;
  /** Filtros adicionales junto al search */
  filters?: React.ReactNode;
  /** Texto de resultados (legacy — prefer meta bar en nuevas páginas) */
  resultsLabel?: string;
  /** Estado de carga */
  loading?: boolean;
  /** Contenido principal */
  children: React.ReactNode;
  /** Empty state */
  emptyState?: React.ReactNode;
  /** Paginación */
  currentPage?: number;
  totalPages?: number;
  onPageChange?: (page: number) => void;
  /** FAB u overlays opcionales */
  fab?: React.ReactNode;
  overlays?: React.ReactNode;
  className?: never;
}

/** @deprecated Prefer ListPageShell for new pages. Thin wrapper for backward compatibility. */
export function MaintainerPageV2({
  header,
  searchValue,
  onSearchChange,
  searchPlaceholder = "Buscar...",
  filters,
  resultsLabel,
  loading,
  children,
  emptyState,
  currentPage,
  totalPages,
  onPageChange,
  fab,
  overlays,
}: MaintainerPageV2Props) {
  const hasContent = React.Children.count(children) > 0;
  const isEmpty = !loading && !hasContent;
  const showInitialLoading = loading && !hasContent;

  return (
    <ListPageShell
      header={header}
      searchValue={searchValue}
      onSearchChange={onSearchChange}
      searchPlaceholder={searchPlaceholder}
      filters={filters}
      loading={showInitialLoading}
      isEmpty={isEmpty}
      emptyState={emptyState}
      showMetaBar={Boolean(resultsLabel)}
      metaSummary={resultsLabel}
      currentPage={currentPage}
      totalPages={totalPages}
      onPageChange={onPageChange}
      rangeLabel={
        currentPage && totalPages
          ? `Página ${currentPage} de ${totalPages}`
          : undefined
      }
      fab={fab}
      overlays={overlays}
    >
      {hasContent ? children : null}
    </ListPageShell>
  );
}
